import axios from 'axios';

const getUserId = () => {
    const docplace = localStorage.getItem('docplace');
    return docplace ? JSON.parse(docplace).userId : null;
};

const getCustomerId = () => {
    const docplace = localStorage.getItem('docplace');
    return docplace ? JSON.parse(docplace).customerId : null;
};

const getToken = () => {
    const docplace = localStorage.getItem('docplace');
    return docplace ? `Bearer ${JSON.parse(docplace).token}` : null;
};

export const startCollaborationSession = async (formId, flowId) => {
    const userId = getUserId();
    const customerId = getCustomerId();
    const token = getToken();

    const response = await axios.post(
        `${process.env.REACT_APP_HOST_WS}/api/v1/live/start-session`,
        {
            form_id: formId,
            flow_id: flowId,
            websocket_id: `ws-${Date.now()}`
        },
        {
            headers: {
                'x-client-id': customerId,
                'x-user-id': userId,
                'Authorization': token,
                'Content-Type': 'application/json'
            }
        }
    );

    return response.data;
};

export const connectToWebSocket = () => {
    const baseUrl = process.env.REACT_APP_HOST_WS;
    const wsBaseUrl = baseUrl.replace(/^http/, 'ws') + '/ws';

    return new WebSocket(wsBaseUrl);
};